import { useSelector as useUntypedSelector } from 'react-redux';
import { StoreState } from './types';
export { actions } from './types';

export function useSelector<TSelected>(selector: (state: StoreState) => TSelected, equalityFn?: (a: TSelected, b: TSelected) => boolean): TSelected {
  return useUntypedSelector<StoreState, TSelected>(selector, equalityFn)
}
